import { DEFAULT_PAGE_SIZE } from '@gurupay/gp-ui-library';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const usePagination = (defaultSize = DEFAULT_PAGE_SIZE) => {
	const { t } = useTranslation();
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(defaultSize);

	const pageOptions = useMemo(
		() => [
			{ label: t('pagination.options.show25'), value: 25 },
			{ label: t('pagination.options.show50'), value: 50 },
			{ label: t('pagination.options.show75'), value: 75 },
		],
		[t],
	);

	const handlePageSizeChange = (newPageSize: number) => {
		setPageSize(newPageSize);
		setCurrentPage(1);
	};

	return {
		currentPage,
		setCurrentPage,
		pageSize,
		pageOptions,
		handlePageSizeChange,
		pageText: t('pagination.pageText'),
		totalCountText: t('pagination.totalResults'),
	};
};
